import { useQuery } from "@tanstack/react-query";
import { getById } from "../../../services/rules";
import { ruleQueryKey } from "./queryKeys";

// Fetches a single rule (with its nested query tree) by id. Server state lives
// here; client UI state is in `queryBuilderSlice`.
export function useRuleQuery(ruleId) {
  return useQuery({
    queryKey: ruleQueryKey(ruleId),
    queryFn: () => getById(ruleId),
    enabled: Boolean(ruleId),
    refetchOnWindowFocus: false,
    retry: 1,
  });
}
